export const HASURA_ENDPOINT = '//hasura.cowsquare.com/v1alpha1/graphql';
export const API_URL = '//auth.cowsquare.com';
